import { render, staticRenderFns } from "./ThemeSwitch.vue?vue&type=template&id=45f8bf86&scoped=true&"
import script from "./ThemeSwitch.vue?vue&type=script&lang=js&"
export * from "./ThemeSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ThemeSwitch.vue?vue&type=style&index=0&id=45f8bf86&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f8bf86",
  null
  
)

export default component.exports